export const createTestAudioBufferSourceNodeStopMethodNullifiedBufferSupport = (createNativeAudioNode) => {
    return (nativeContext) => {
        const nativeAudioBufferSourceNode = createNativeAudioNode(nativeContext, (ntvCntxt) => ntvCntxt.createBufferSource());
        nativeAudioBufferSourceNode.start();
        try {
            nativeAudioBufferSourceNode.stop();
        }
        catch (_a) {
            return false;
        }
        return true;
    };
};
//# sourceMappingURL=/build/es2018/factories/test-audio-buffer-source-node-stop-method-nullified-buffer-support.js.map